import Vue from "vue";
import UserProfileWidget from "./components/UserProfile.vue";
import store from './store/index';

Vue.config.productionTip = false;

let UserProfileWidgets = document.querySelectorAll('widget-user-profile');
if (UserProfileWidgets.length) {
    UserProfileWidgets.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                let language = this.$el.attributes.getNamedItem('language');
                let labels = this.$el.attributes.getNamedItem('labels');
                let passwordUrl = this.$el.attributes.getNamedItem('password-url');
                let disabilitiesUrl = this.$el.attributes.getNamedItem('disabilities-url');
                let studielinkUrl = this.$el.attributes.getNamedItem('studielink-url');

                return h(UserProfileWidget, {
                    props: {
                        configRaw: {
                            language: language ? language.value : null,
                            labels: labels ? JSON.parse(labels.value) : null,
                            passwordUrl: passwordUrl ? passwordUrl.value : null,
                            disabilitiesUrl: disabilitiesUrl ? disabilitiesUrl.value : null,
                            studielinkUrl: studielinkUrl ? studielinkUrl.value : null
                        }                        
                    }
                });
            }
        });
    });
}
